import { Model } from 'pinia-orm';
import Interim from "./Interim";
import InterimMatrixType from "./InterimMatrixType";

export default class InterimMatrixTypeValue extends Model {

    static get entity () {
        return 'interim-matrix-type-values';
    }

    static fields () {
        return {
            id: this.uid(() => null),
            value: this.string(''),
            interim_id: this.attr(''),
            type_id: this.attr(''),
            created_at: this.attr(null),
            updated_at: this.attr(null),

            // Relationships
            interim: this.belongsTo(Interim, 'interim_id'),
            type: this.belongsTo(InterimMatrixType, 'type_id')
        }
    }
}
